import { Global } from "./Global"
import Signal from "../Common/Signal"

const ZIndexDomainUI = 999		// 高于loadinCircleUI
const ZIndexLoadingUI = 998

class UIManager {
	private _loadingCircleUI: cc.Node = null
	private _toastUI: cc.Node = null
	private _changeDomainUI: cc.Node = null
	private _isLoadingCircleUIHidden: boolean = false
	public confirmBox: cc.Node = null;
	public boxNum = 0;
	
	/**
	 * 显示提醒横幅
	 * @param content 
	 * @param toastType 
	 */
	showToastUI (content: string, toastType?: Global.ToastType) {
		if (this._toastUI && this._toastUI.isValid) return
		cc.loader.loadRes('Common/Toast', cc.Prefab, function (err, prefab) {
	        if (!err && (!this._toastUI || !this._toastUI.isValid)) {
	            this._toastUI = cc.instantiate(prefab)
	            let toast = this._toastUI.getComponent('ToastUI')

                toast.content = content
                toast.toastType = toastType
	            this._toastUI.parent = cc.Canvas.instance.node
	        }
	    }.bind(this))
	}

	/**
	 * 隐藏提醒横幅
	 */
	hideToastUI () {
		if (this._toastUI) {
			this._toastUI.destroy()
			this._toastUI = null
		}
	}

	/***
	 * 提示框
	 * @param content
	 * @param cb
	 * @param textOK
	 */
	async showTipUI(content: string, cb?, textOK?) {
		if (this.confirmBox) {
			this.confirmBox.active = true;
			this.confirmBox.parent = cc.Canvas.instance.node
			let msgBox = this.confirmBox.getComponent('ConfirmBox');
			msgBox.showTip(content, cb, textOK);
		} else {
			await this.loadTipBox(content, cb, textOK);
		}

	}

	/***
	 *确认框
	 * @param content 内容
	 * @param cbYes    确定回调
	 * @param textYes    按钮文本
	 * @param cbNo    取消回调
	 * @param textNo 按钮文本
	 */
	async showConfirmUI(content: string, cbYes?, textYes?, cbNo?, textNo?) {
		this.boxNum ++;
		if (this.boxNum > 1) return ; //防止频繁调用确认框；
		if (this.confirmBox) {
			return ;
			this.confirmBox.active = true;
			this.confirmBox.parent = cc.Canvas.instance.node
			let confirmBox = this.confirmBox.getComponent('ConfirmBox');
			confirmBox.showConfirm(content, cbYes, textYes, cbNo, textNo);
		} else {
			await this.loadConfirmBox(content, cbYes, textYes, cbNo, textNo);
		}
	}

	/**
	 * 显示切换线路的界面
	 * @param callback 
	 */
	showChangeDomainUI (callback?: Function) {
		if (this._changeDomainUI) return;
		cc.loader.loadRes("Common/Signal", function (err, prefab) {
			if (!err && !this._changeDomainUI) {
				let signal = cc.instantiate(prefab).getComponent(Signal)
				this._changeDomainUI = signal.node
				this._changeDomainUI.zIndex = ZIndexDomainUI
				this._changeDomainUI.parent = cc.Canvas.instance.node
				signal.callback = function () {
					this._changeDomainUI = null
					callback && callback()
				}.bind(this)
			}else {
				cc.error("==加载错误")
			}
		}.bind(this))

	}

	private loadConfirmBox(content, cbYes?, textYes?, cbNo?, textNo?):Promise<void>{
		return new Promise<void>( (resolve) =>{
			cc.loader.loadRes('Common/ConfirmBox', cc.Prefab, function (err, prefab) {
				if (!err) {
					this.confirmBox = cc.instantiate(prefab);
					this.confirmBox.parent = cc.Canvas.instance.node
					let confirmBox = this.confirmBox.getComponent('ConfirmBox');
					confirmBox.showConfirm(content, cbYes, textYes, cbNo, textNo);
					cc.log("===进入确认框---");
					resolve()
				}
				else{
					cc.log("===进入确认框err");
					resolve();
				}
			}.bind(this))
		})
	}

	private loadTipBox(content, cbYes?, textYes?):Promise<void>{
		return new Promise<void>( (resolve) =>{
			cc.loader.loadRes('Common/ConfirmBox', cc.Prefab, function (err, prefab) {
				if (!err) {
					this.confirmBox = cc.instantiate(prefab);
					this.confirmBox.parent = cc.Canvas.instance.node
					let confirmBox = this.confirmBox.getComponent('ConfirmBox');
					confirmBox.showTip(content, cbYes, textYes);
					cc.log("===进入确认框---");
					resolve()
				}
				else{
					cc.log("===进入确认框err");
					resolve();
				}
			}.bind(this))
		})
	}

	showLoadingUI () {
		if (this._loadingCircleUI) {
	    	return
	    }

		this._isLoadingCircleUIHidden = false;
	    cc.loader.loadRes('Common/LoadingCircle', cc.Prefab, function (err, prefab) {
	        if (!err && !this._loadingCircleUI && !this._isLoadingCircleUIHidden) {
	            this._loadingCircleUI = cc.instantiate(prefab);
	            this._loadingCircleUI.zIndex = ZIndexLoadingUI;
	            this._loadingCircleUI.parent = cc.Canvas.instance.node
	        }
	    }.bind(this))
	}

	hideLoadingUI () {
	    if (this._loadingCircleUI) {
	    	this._loadingCircleUI.destroy();
	    	this._loadingCircleUI = null
	    }

	    this._isLoadingCircleUIHidden = true;
	}
}

export default new UIManager()